import { F, C, N, Streams } from '@masala/parser'
import { X } from '@masala/x'

export function getSwaapErrorCode(errorString: any): number | undefined {

  if (typeof errorString !== 'string') {
    return undefined
  }


  const swaapParser = C.string('SWAAP#').drop().then(N.digits()).single()

  const fullParser = F.moveUntil(swaapParser).drop().then(swaapParser).single()
  return fullParser.val(errorString)
}

export function getProxyErrorCode(errorString: any): number | undefined {

  if (typeof errorString !== 'string') {
    return undefined
  }

  const proxyParser = C.string('PROOXY#').drop().then(N.digits()).single()

  const fullParser = F.moveUntil(proxyParser).drop().then(proxyParser).single()
  return fullParser.val(errorString)
}


export function getErc20Error(errorString: any): string | undefined {
  if (typeof errorString !== 'string') {
    return undefined
  }
  errorString = errorString.trim()
  const message = dropStart(errorString, 'ERC20:')
  return message ? capitalize(message) : undefined
}

export function getMessageFromErrorParser(errorString: any): string {
  if (typeof errorString !== 'string') {
    return errorString
  }

  const parser = F.dropTo('\n').then(X.json()).single()
  const value = parser.val(errorString)

  if (typeof value !== 'object' || !value.message) {
    return errorString
  }

  // try reverted reason
  const message = value.message

  const anyParser = F.any()
    .rep()
    .map(x => {
      return x.join('')
    })
  const revertParser = F.dropTo('reverted: ').then(anyParser).single()

  const response = revertParser.parse(Streams.ofString(message))
  if (response.isAccepted()) {
    {
      return response.value
    }
  } else {
    return message
  }
}

function dropStart(str: any, toDrop: string, trim = true): string | undefined {
  if (typeof str !== 'string') {
    return undefined
  }
  if (trim) {
    str = str.trim()
  }

  const start = toDrop.length
  if (str.indexOf(toDrop) !== 0) {
    return undefined
  }
  return trim ? str.trim().slice(start).trim() : str.slice(start)
}

function capitalize(str: string) {
  if (str.length <= 1) {
    return str
  }
  const lower = str.toLowerCase()
  return str.charAt(0).toUpperCase() + lower.slice(1)
}
